import { WIZARD_STEPS } from "./types";

interface WizardProgressProps {
  current: number;
  onGoTo: (step: number) => void;
}

export default function WizardProgress({ current, onGoTo }: WizardProgressProps) {
  const percent = Math.round(((current + 1) / WIZARD_STEPS.length) * 100);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm font-label font-semibold text-foreground-950">
          Paso {current + 1} de {WIZARD_STEPS.length}
        </span>
        <span className="text-xs font-label text-foreground-500">{percent}% completado</span>
      </div>

      <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
        <div
          className="h-full rounded-full bg-primary-500 transition-all duration-300"
          style={{ width: `${percent}%` }}
        ></div>
      </div>

      <ol className="mt-4 flex flex-wrap gap-2">
        {WIZARD_STEPS.map((step, index) => {
          const done = index < current;
          const active = index === current;
          return (
            <li key={step.id}>
              <button
                type="button"
                onClick={() => onGoTo(index)}
                disabled={!done && !active}
                className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-label font-medium transition-colors ${
                  active
                    ? "border-primary-400 bg-primary-50 text-primary-800"
                    : done
                      ? "cursor-pointer border-secondary-200 bg-secondary-50 text-secondary-900 hover:border-primary-300"
                      : "border-background-200 bg-background-100 text-foreground-400"
                }`}
              >
                {done ? (
                  <i className="ri-checkbox-circle-fill text-sm leading-none text-primary-600" aria-hidden="true"></i>
                ) : (
                  <span className="flex h-4 w-4 items-center justify-center rounded-full bg-background-200 text-[10px]">
                    {index + 1}
                  </span>
                )}
                {step.short}
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}